.button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: var(--layout-control-height-md);
  height: var(--layout-control-height-md);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  color: var(--color-text-muted);
  transition:
    background-color var(--duration-fast) var(--ease-out),
    color var(--duration-fast) var(--ease-out);
}

.button:disabled {
  opacity: 0.5;
}

.icon {
  display: inline-flex;
}

.icon > svg {
  width: 1.25rem;
  height: 1.25rem;
}

.sm {
  width: var(--layout-control-height-sm);
  height: var(--layout-control-height-sm);
}

.sm .icon > svg {
  width: 1rem;
  height: 1rem;
}

.lg {
  width: var(--layout-control-height-lg);
  height: var(--layout-control-height-lg);
}

.lg .icon > svg {
  width: 1.5rem;
  height: 1.5rem;
}

.ghost:hover:not(:disabled) {
  background-color: var(--color-surface-hover);
  color: var(--color-text);
}

.secondary {
  background-color: var(--color-surface);
  border-color: var(--color-border-strong);
  color: var(--color-text);
}

.secondary:hover:not(:disabled) {
  background-color: var(--color-surface-hover);
}

.primary {
  background-color: var(--color-primary);
  color: var(--color-primary-contrast);
}

.primary:hover:not(:disabled) {
  background-color: var(--color-primary-hover);
}

.danger {
  color: var(--color-danger-fg);
}

.danger:hover:not(:disabled) {
  background-color: var(--color-danger-bg);
}

/* For use on the navigation surface. */
.nav {
  color: var(--color-nav-text);
}

.nav:hover:not(:disabled) {
  background-color: var(--color-nav-item-hover-bg);
  color: var(--color-nav-text-active);
}

.nav:focus-visible {
  outline-color: var(--color-nav-focus-ring);
}

.badge {
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 1.05rem;
  height: 1.05rem;
  padding: 0 0.25rem;
  border-radius: var(--radius-full);
  border: 2px solid var(--color-topbar-bg);
  background-color: var(--color-danger-solid);
  color: #ffffff;
  font-size: 0.625rem;
  font-weight: var(--font-weight-bold);
  line-height: 0.85rem;
  text-align: center;
  font-variant-numeric: tabular-nums;
  box-sizing: content-box;
  transform: translate(25%, -25%);
}
